import React, { memo } from 'react'
import { Avatar } from '@mui/material'

const UserProfileAvatar = ({
  size = 50,
  children,
  invert = false,
  src,
  sx,
  ...restProps
}) => {
  const bgStyle = !src
    ? invert
      ? { color: 'custom.black', backgroundColor: 'custom.white' }
      : { color: 'custom.white', backgroundColor: 'custom.black' }
    : src

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        color: 'custom.white',
        ...bgStyle,
        ...sx
      }}
      src={src}
      {...restProps}
    >
      {children}
    </Avatar>
  )
}

export default memo(UserProfileAvatar)
